document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('.quick-add-form')) return;
  event.preventDefault();
  const button = form.querySelector('button');
  const previous = button.textContent;
  button.textContent = 'Añadiendo...';
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } });
    if (!response.ok) throw new Error('No se pudo añadir');
    button.textContent = 'Añadido ✓';
    const cart = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
  } catch (error) {
    button.textContent = 'Error';
  }
  setTimeout(() => { button.textContent = previous; }, 1700);
});


/* ================================
   TCG Glow controller v27
   - Recoloca el botón flotante en móvil para que no tape comprar
   - Oculta Glow en la home para no molestar de primeras
   - Permite abrir Glow desde botones del theme
================================ */
(function(){
  const isHome = document.body.classList.contains('template-index');
  const isRewardsPage = document.body.classList.contains('page-recompensas');
  const labels = {
    referral: ['refer','referral','amigo','invita','referido','share'],
    redeem: ['redeem','redimir','canjear','reward','recompensa','get rewards'],
    earn: ['earn','gana','ganar','puntos','how to earn'],
    balance: ['balance','saldo','points','puntos','history','historial']
  };

  function visible(el){
    if(!el || el.closest('.glow-rewards-page')) return false;
    const s = window.getComputedStyle(el);
    const r = el.getBoundingClientRect();
    return s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity || 1) !== 0 && r.width > 0 && r.height > 0;
  }

  function glowCandidates(){
    const selectors = [
      '[id*="glow" i]', '[class*="glow" i]', 'iframe[src*="glow" i]',
      'button[aria-label*="reward" i]', 'button[title*="reward" i]',
      'button[aria-label*="recomp" i]', 'button[title*="recomp" i]'
    ];
    return [...document.querySelectorAll(selectors.join(','))]
      .filter(el => !el.closest('.glow-rewards-page') && !el.closest('.site-header') && !el.closest('main .product-card'));
  }

  function launcherCandidates(){
    return glowCandidates().filter(el => {
      const r = el.getBoundingClientRect();
      const s = window.getComputedStyle(el);
      const txt = ((el.innerText || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' + (el.className || '') + ' ' + (el.id || '')).toLowerCase();
      const looksFixed = ['fixed','sticky'].includes(s.position) || r.bottom > window.innerHeight - 180 || r.right > window.innerWidth - 180;
      const looksSmall = r.width <= 460 && r.height <= 520;
      const glowText = /glow|reward|recomp|loyalty|puntos|points/.test(txt);
      return looksFixed && looksSmall && glowText;
    });
  }

  function tagGlow(){
    launcherCandidates().forEach(el => {
      el.classList.add('tcg-glow-widget');
      const parent = el.parentElement;
      if(parent){
        const ps = window.getComputedStyle(parent);
        const pr = parent.getBoundingClientRect();
        if(['fixed','sticky'].includes(ps.position) || pr.bottom > window.innerHeight - 220){
          parent.classList.add('tcg-glow-widget-wrap');
        }
      }
    });
  }

  function applyGlowPosition(){
    tagGlow();
    const nodes = [...document.querySelectorAll('.tcg-glow-widget,.tcg-glow-widget-wrap')];
    nodes.forEach(el => {
      if(isHome && !isRewardsPage){
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
        el.style.transform = 'translateY(16px) scale(.92)';
        return;
      }
      el.style.opacity = '';
      el.style.pointerEvents = '';
      if(window.innerWidth <= 749 && !isRewardsPage){
        el.style.left = '14px';
        el.style.right = 'auto';
        el.style.bottom = '92px';
        el.style.zIndex = '2147483000';
      } else if(isRewardsPage){
        el.style.right = '18px';
        el.style.left = 'auto';
        el.style.bottom = '22px';
        el.style.zIndex = '2147483000';
      }
    });
  }

  function clickGlowLauncher(){
    applyGlowPosition();
    const candidates = launcherCandidates().filter(visible);
    const preferred = candidates.find(el => /reward|recomp|loyalty|puntos|points|glow/.test(((el.innerText || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' + (el.className || '')).toLowerCase()));
    const target = preferred || candidates[candidates.length - 1];
    if(target){ target.click(); return true; }
    return false;
  }

  function clickInsideGlow(section){
    const words = labels[section] || [];
    if(!words.length) return;
    setTimeout(() => {
      const candidates = [...document.querySelectorAll('button,a,[role="button"]')].filter(visible);
      const match = candidates.find(el => {
        const txt = ((el.innerText || '') + ' ' + (el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('title') || '')).toLowerCase();
        return words.some(w => txt.includes(w));
      });
      if(match) match.click();
    }, 700);
  }

  window.TCGOpenGlowRewards = function(section){
    const ok = clickGlowLauncher();
    if(ok) clickInsideGlow(section || 'balance');
    return ok;
  };

  document.addEventListener('click', function(e){
    const openBtn = e.target.closest('[data-open-glow], .glow-open-widget');
    if(!openBtn) return;
    e.preventDefault();
    window.TCGOpenGlowRewards(openBtn.dataset.glowTarget || 'balance');
  });

  // Recolocar al cargar y cuando Glow se inyecte tarde.
  const observer = new MutationObserver(applyGlowPosition);
  observer.observe(document.documentElement, {childList:true, subtree:true});
  window.addEventListener('resize', applyGlowPosition, {passive:true});
  window.addEventListener('load', applyGlowPosition);
  setTimeout(applyGlowPosition, 800);
  setTimeout(applyGlowPosition, 2200);
})();
